<svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
    <g fill="none" fill-rule="evenodd" stroke="#000" stroke-width="1.5" transform="translate(1 1)">
        <path d="M.01 2.528l1.6 13.145c.11 1.07 2.566 1.927 5.59 1.927s5.48-.856 5.59-1.927l1.6-13.145"/>
        <ellipse cx="7.2" cy="2.4" stroke-linecap="square" rx="7.2" ry="2.4"/>
    </g>
</svg>
